// @flow
import Dispatcher from 'dispatcher';
import ApiClient from 'utils/ApiClient';
import RentFeeOwner from 'models/RentFeeOwner';
import * as CampaignActionTypes from 'action_types/CampaignActionTypes';
import _ from 'lodash';

class CampaignActions {
  getMarketingCampaigns(campaignName): Promise<any>  {
    return ApiClient.get({
      path: `/api/internal/rent_fee_for_owners/marketing_campaigns/${campaignName}.json`,
      skipApiUrl: true,
      success: response => {
        if(_.has(response, 'marketing_campaign.rent_fee_for_owner')) {
          Dispatcher.dispatch({
            type: CampaignActionTypes.GET_CAMPAIGN,
            campaign: new RentFeeOwner(response)
          });
        }
      }
    });
  }
}

export default new CampaignActions();
